/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable react-hooks/exhaustive-deps */
import Header from "../header/Header";
import "../../App.css";
import { useEffect, useState, useCallback } from "react";
import { Modal, Table, Tag } from "antd";
import { useQuery } from "@tanstack/react-query";
import { getUserQuoteById } from "../../lib/quotes";
import { generatePDF } from "../shared/pdf/generatePDF";
import { toast } from "react-toastify";
import { doc, getDoc } from "firebase/firestore";
import { db } from "../../config/firebase";
import { FormatDate } from "../../lib/dateFormat";
import DashboardLayout from "../layout";
import InvoiceModal from "../shared/common/invoiceModal";
import { useMyContext } from "../../context/MyContext";
import { FaDownload, FaRegEye } from "react-icons/fa6";
import Loader from "../shared/loader/loader";
import { Loader2 } from "lucide-react";

function ShipmentHistory() {
  const obj = {
    active: true,
    content: "My Invoice",
  };

  const { user } = useMyContext();
  const [modalOpen, setModalOpen] = useState(false);
  const [shipmentData, setShipmentData] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [formData, setFormData] = useState(null);
  const [loadingPdf, setLoadingPdf] = useState(false);
  const [filteredData, setFilteredData] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [showLoader, setShowLoader] = useState(true);
  const [loadingStates, setLoadingStates] = useState({})
  console.log('filteredData', filteredData);

  //helper function to manage multiple action loading states for each row item
  const setLoading = (id, action, value) => {
    setLoadingStates((prev) => ({
      ...prev,
      [id]: {
        ...prev[id],
        [action]: value
      }
    }))
  }

  const { data } = useQuery(
    ["userQuotes", user?.uid, "completed"],
    async () => {
      const res = await getUserQuoteById(user?.uid);
      return res?.filter((item) => item?.status?.toLowerCase() === "completed");
    },
    {
      refetchOnWindowFocus: false,
    }
  );

  useEffect(() => {
    if (data) {
      setFilteredData(data);
      setShowLoader(false);

    }
  }, [data]);

  useEffect(() => {
    if (data && Array.isArray(data)) {
      const sortedData = [...data].sort(
        (a, b) => new Date(b.creationDate) - new Date(a.creationDate)
      );
      setFilteredData(sortedData);
      setShowLoader(false);
    }
  }, [data]);

  const handleOk = () => {
    setIsModalOpen(false);
  };

  const handleCancel = () => {
    setIsModalOpen(false);
  };

  const handleGeneratePdf = async (quote) => {
    setLoading(quote.id, "download", true);
    try {
      const userDocRef = doc(db, "quotes", quote.id);
      const userDocSnap = await getDoc(userDocRef);

      if (userDocSnap.exists()) {
        const data = userDocSnap.data();
        setFormData(data);
      } else {
        toast.error("Quote data not found");
      }

      if (formData) {
        const blob = await generatePDF(formData);
        const link = document.createElement("a");
        link.href = URL.createObjectURL(blob);
        link.download = "quotation.pdf";
        link.click();
      }

    } catch (error) {
      toast.error("Error fetching Quote data:", error);
    } finally {
      setLoading(quote.id, "download", false);
    }
  };

  const FilterData = useCallback(() => {
    if (!data || !Array.isArray(data)) return;

    if (!searchQuery.trim()) {
      setFilteredData(
        [...data].sort(
          (a, b) => new Date(b.creationDate) - new Date(a.creationDate)
        )
      );
    } else {
      const filtered = data.filter((directory) =>
        Object.values(directory).some(
          (value) =>
            typeof value === "string" &&
            value.toLowerCase().includes(searchQuery.toLowerCase())
        )
      );
      setFilteredData(
        filtered.sort(
          (a, b) => new Date(b.creationDate) - new Date(a.creationDate)
        )
      );
    }
  }, [searchQuery, data]);

  useEffect(() => {
    FilterData();
  }, [searchQuery, FilterData]);

  const openInvoiceModal = (data) => {
    setShipmentData(data);
    setModalOpen(true);
  };

  const [pdfUrl, setPdfUrl] = useState(null);

  const handleViewPdf = async (quote) => {
    setLoading(quote.id, 'view', true)
    try {
      const pdfBlob = await generatePDF(quote);
      const pdfUrl = URL.createObjectURL(pdfBlob);
      setPdfUrl(pdfUrl);
    } catch (error) {
      toast.error("Error generating PDF:", error);
    } finally {
      setLoading(quote.id, 'view', false)
    }
  };

  const columns = [
    {
      title: "Quote Number",
      dataIndex: "quoteNumber",
    },
    {
      title: "Order Number",
      dataIndex: "orderNumber",
    },
    {
      title: "Invoice date",
      dataIndex: "creationDate",
      render: (creationDate) => FormatDate(creationDate),
      defaultSortOrder: "ascend",
      sorter: (a, b) => new Date(b.creationDate) - new Date(a.creationDate),
    },
    {
      title: "View/download ",
      render: (_, record) => (
        <div className="flex space-x-2">
          <button
            onClick={() => handleViewPdf(record)}
            disabled={loadingStates[record.id]?.view}
            className="py-1 px-3 rounded-md bg-[#A9A9A9] text-white disabled:bg-opacity-50"
          >
            {loadingStates[record.id]?.view ? (
              <Loader2 className="animate-spin" />
            ) : (
              <FaRegEye className="text-2xl" />
            )}
          </button>
          <button
            onClick={() => handleGeneratePdf(record)}
            disabled={loadingStates[record.id]?.download}
            className="py-1 px-3 rounded-md bg-[#3861DC] text-white disabled:bg-opacity-50"
          >
            {loadingStates[record.id]?.download ? (
              <Loader2 className="animate-spin" />
            ) : (
              <FaDownload className="text-2xl" />
            )}
          </button>
        </div>
      ),
    },
    {
      title: "Invoice due date",
      dataIndex: "validityDate",
      render: (validityDate) => FormatDate(validityDate),
    },

    {
      title: "Status",
      dataIndex: "status",
      render: (status) => (
        <Tag className="border text-center text-white bg-green-500 px-3 py-1 rounded-md min-w-[80px] inline-block">
          {status}
        </Tag>
      ),
    },
  ];

  return (
    <>
      <Modal
        title="Comment"
        open={isModalOpen}
        centered
        footer={null}
        onOk={handleOk}
        onCancel={handleCancel}
      >
        <textarea className="w-full h-[100px] border border-gray-300 p-2 rounded-md focus:outline-none" />
        <button className="mt-4 w-[130px] text-white rounded-md h-[40px] bg-blue-700">
          Send
        </button>
      </Modal>
      {pdfUrl && (
        <Modal
          title="Quotation"
          visible={true}
          onCancel={() => setPdfUrl(null)}
          footer={null}
          width="60%"
        >
          <iframe
            src={`${pdfUrl}#toolbar=0`}
            title="Quotation PDF"
            style={{ width: "100%", height: "70vh", border: 0 }}
          ></iframe>
        </Modal>
      )}
      <DashboardLayout>
        <div className="w-full h-full">
          <Header title="Shipment History" />
          <div className="p-4 bg-cus-gray h-full">

            <div className="mb-4 flex flex-col items-center justify-end gap-5 p-3 bg-white rounded-md md:p-5 gap-y-4 md:flex-row">
              <div className="flex flex-col w-full gap-1 md:flex-row">
              </div>

              <div className="w-full md:w-auto p-3 flex space-x-2 items-center rounded-[5px] border-2 border-blue">
                <input
                  placeholder="Search here"
                  className="outline-none w-full"
                  type="text"
                  value={searchQuery}
                  onChange={(e) => setSearchQuery(e.target.value)}
                  style={{ color: "rgba(24, 24, 24, 0.53)" }}
                />
              </div>
            </div>
            {showLoader ? (
              <Loader />
            ) : (
              <div className="flex items-center justify-between  mt-4 bg-white rounded-md">
                <div className="w-full">
                  <Table
                    columns={columns}
                    dataSource={Array.isArray(filteredData) ? filteredData : []}
                    size="small"
                    className="table w-full border-0 mx-auto"
                  />
                </div>
              </div>
            )}
          </div>
        </div>
      </DashboardLayout>
      {modalOpen && (
        <InvoiceModal
          setModalOpen={setModalOpen}
          modalOpen={modalOpen}
          shipmentData={shipmentData}
          setShipmentData={setShipmentData}
        />
      )}
    </>
  );
}

export default ShipmentHistory;
